import {Component} from "@angular/core";
import {Api} from "../shared/api.service";
import {Message, MessageCollection, MessageCollectionRespone} from "../shared/api/messages/api.models";
import * as moment from 'moment';
import {Pagination} from "../shared/api/pagination.interface";
import {Blob} from "../shared/api/attachments/api.models";
import {ActivatedRoute, Router} from "@angular/router";
import {GroupedLanguages}                  from "../shared/languages.resolver";
import {Language}                                  from "../shared/api/languages/api.models";
import {AuthenticationService}                     from "../shared/authentication.service";
import {Me}                                        from "../shared/api/me/me.models";
import {ModalService}                              from '../shared/modal.service';
import {MessageModal}                              from './components/message.modal';
import {Permission}                                from '../shared/api/permissions/api.models';
import {Subject}                                   from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';

@Component({
    selector : 'message-overview',
    template: require('./overview.component.html'),
    styles: [require('./overview.component.scss')]
})

export class MessageOverviewComponent {
    currentPage: number;
    perPage: number = 20;
    collectionSize: number;

    protected subject?: string = null;
    protected content?: string = null;
    protected status?: string = null;
    protected type?: string = null;
    protected chainLength?: number = null;
    protected behaviour?: string = null;
    protected attachment?: string = null;
    protected tag?: string = null;
    protected languageId?: number = null;

    protected statusses: string[] = MessageCollection.statuses;
    protected types: string[] = Message.types;
    protected tags: string[] = MessageCollection.tags;
    protected behaviours: string[] = MessageCollection.behaviours;

    protected messageCollections: MessageCollection[] = [];
    protected storedMessages: Message[] = [];
    protected blob: Blob;

    protected languages: GroupedLanguages[] = [];
    protected languagesHash: any = {};

    protected me: Me;

    protected filter: any = {
        subject: null,
        content: null
    };

    protected subjectChanged: Subject<string> = new Subject<string>();
    protected contentChanged: Subject<string> = new Subject<string>();

    protected isSearching: boolean = false;

    constructor(private api: Api, private modal: ModalService, private route: ActivatedRoute, private router: Router, private auth: AuthenticationService) {}

    ngOnInit(): void {
        this.me        = this.auth.getMe();
        this.languages = this.route.snapshot.data['languages'] as GroupedLanguages[];
        this.languages.forEach((groupedLanguages: GroupedLanguages) => {
            groupedLanguages.languages.forEach((language: Language) => {
                this.languagesHash[language.id] = language;
            });
        });

        this.subjectChanged.pipe(
            debounceTime(400),
            distinctUntilChanged()
        ).subscribe(() => {
            this.loadPage(1);
        });

        this.contentChanged.pipe(
            debounceTime(400),
            distinctUntilChanged()
        ).subscribe(() => {
            this.loadPage(1);
        });

        this.loadPage(1);
    }

    loadPage(page: number) {
        this.currentPage = page;
        this.isSearching = true;
        this.messageCollections = [];

        this.api.messages().collection(
            this.currentPage,
            this.perPage,
            this.filter.subject || null,
            this.filter.content || null,
            this.status,
            null,
            null,
            this.type,
            this.chainLength,
            this.attachment,
            this.behaviour,
            this.tag ? [this.tag] : null,
            this.languageId ? [this.languageId] : this.me.preferences.languages,
            true
        ).subscribe((messages: MessageCollectionRespone) => {
            this.isSearching = false;
            this.setMessages(messages);
        });
    }

    setMessages(messages: MessageCollectionRespone) {
        if (messages.result.length === 0 && this.currentPage > 1) {
            return this.loadPage(this.currentPage - 1);
        }

        messages.result.forEach((messageCollection: MessageCollection) => {
            messageCollection.messages.forEach((message: Message) => {
                message.updated = moment(message.updated).format('YYYY-MM-DD hh:mm:ss');
            });
        });

        this.messageCollections = messages.result;
        this.setPagination(messages.pagination);
    }

    changeStatus(event: Event) {
        this.status = event.target['value'] ? event.target['value'] : null;
        this.loadPage(1);
    }

    changeType(event: Event) {
        this.type = event.target['value'] ? event.target['value'] : null;
        this.loadPage(1);
    }

    changeAttachment(event: Event) {
        this.attachment = event.target['value'] ? event.target['value'] : null;
        this.loadPage(1);
    }

    changeBehaviour(event: Event) {
        this.behaviour = event.target['value'] ? event.target['value'] : null;
        this.loadPage(1);
    }

    changeChainLength(event: Event) {
        this.chainLength = event.target['value'] ? Number.parseInt(event.target['value']) : null;
        this.loadPage(1);
    }

    changeTag(event: Event) {
        this.tag = event.target['value'] ? event.target['value'] : null;
        this.loadPage(1);
    }

    changeLanguage(event: Event) {
        this.languageId = event.target['value'] ? Number.parseInt(event.target['value']) : null;
        this.loadPage(1);
    }

    changeSubject() {
        this.subjectChanged.next(this.filter.subject);
    }

    changeContent() {
        this.contentChanged.next(this.filter.content);
    }

    showFull(collection: MessageCollection) {
        let modal = this.modal.custom(MessageModal);
        modal.componentInstance.messageCollection = collection;
        modal.componentInstance.showRemoveButton  = this.auth.canDoAny([Permission.MESSAGES_DELETE]);
        modal.componentInstance.showEditButton    = this.auth.canDoAny([Permission.MESSAGES_EDIT_MESSAGES]);

        modal.result.then(
            () => {
                this.modal.confirm(
                    "Remove message",
                    "Are you sure you want to remove this message?"
                ).then(
                    () => {
                        this.messageCollections.splice(this.messageCollections.indexOf(collection), 1);
                        this.api.messages().remove(collection.id).subscribe(
                            () => {
                                this.loadPage(this.currentPage);
                            }
                        );
                    },
                    () => {
                        this.showFull(collection);
                    }
                );
            },
            (dismissData) => {
                if (dismissData && dismissData.type === 'edit') {
                    this.router.navigate(['/messages/edit'], { queryParams : { messageId : dismissData.messageId }});
                }
            }
        );
    }

    private setPagination(pagination: Pagination) {
        this.currentPage    = pagination.current;
        this.collectionSize = pagination.total;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/messages/overview.component.ts